import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { resolve as urlResolve } from 'url';
import { getIsDarkTheme } from 'owa-fabric-theme';
var SVG_BASE_PATH = 'resources/images/surfaceActions';
var ATTACH_SVG = SVG_BASE_PATH + "/attach.svg";
var ATTACHDARK_SVG = SVG_BASE_PATH + "/attachDark.svg";
var INLINEIMAGE_SVG = SVG_BASE_PATH + "/inlineimage.svg";
var INLINEIMAGEDARK_SVG = SVG_BASE_PATH + "/inlineimageDark.svg";
var EMOJI_SVG = SVG_BASE_PATH + "/emoji.svg";
var SHOWRIBBON_SVG = SVG_BASE_PATH + "/showribbon.svg";
var SHOWRIBBONDARK_SVG = SVG_BASE_PATH + "/showribbonDark.svg";
export function getComposeActionIconName(key) {
    var iconName;
    var fallbackIconName;
    var isImage = false;
    switch (key) {
        case 'AddAttachment':
            iconName = urlResolve(getPackageBaseUrl(), getIsDarkTheme() ? ATTACHDARK_SVG : ATTACH_SVG);
            fallbackIconName = urlResolve(getPackageBaseUrl(), ATTACH_SVG);
            isImage = true;
            break;
        case 'AddInlineImage':
            iconName = urlResolve(getPackageBaseUrl(), getIsDarkTheme() ? INLINEIMAGEDARK_SVG : INLINEIMAGE_SVG);
            fallbackIconName = urlResolve(getPackageBaseUrl(), INLINEIMAGE_SVG);
            isImage = true;
            break;
        case 'AddEmoji':
            iconName = urlResolve(getPackageBaseUrl(), EMOJI_SVG);
            isImage = true;
            break;
        case 'ToggleRibbon':
            iconName = urlResolve(getPackageBaseUrl(), getIsDarkTheme() ? SHOWRIBBONDARK_SVG : SHOWRIBBON_SVG);
            fallbackIconName = urlResolve(getPackageBaseUrl(), SHOWRIBBON_SVG);
            isImage = true;
            break;
        case 'ProtectMessage':
            iconName = "Encryption" /* Encryption */;
            break;
        case 'SaveDraft':
            iconName = "Save" /* Save */;
            break;
        case 'InsertSignature':
            iconName = "InsertSignatureLine" /* InsertSignatureLine */;
            break;
        case 'ShowFrom':
            iconName = "ArrangeByFrom" /* ArrangeByFrom */;
            break;
        case 'SetImportance':
            iconName = "Important" /* Important */;
            break;
        case 'SwitchBodyType':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'AccChecker':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        default:
            iconName = '';
            break;
    }
    return {
        iconName: iconName,
        fallbackIconName: fallbackIconName || iconName,
        isImage: isImage,
    };
}
export function getReadActionIconName(key) {
    var iconName;
    switch (key) {
        case '-':
            iconName = '-';
            break;
        case 'Reply':
            iconName = "Reply" /* Reply */;
            break;
        case 'ReplyAll':
            iconName = "ReplyAll" /* ReplyAll */;
            break;
        case 'Forward':
            iconName = "Forward" /* Forward */;
            break;
        case 'Delete':
            iconName = "Delete" /* Delete */;
            break;
        case 'MarkReadUnread':
            iconName = "Mail" /* Mail */;
            break;
        case 'FlagUnflag':
            iconName = "Flag" /* Flag */;
            break;
        case 'MarkJunkNotJunk':
            iconName = "MailAlert" /* MailAlert */;
            break;
        case 'MarkAsPhishing':
            iconName = "Phishing" /* Phishing */;
            break;
        case 'Block':
            iconName = "BlockContact" /* BlockContact */;
            break;
        case 'CreateRule':
            iconName = "CreateMailRule" /* CreateMailRule */;
            break;
        case 'Print':
            iconName = "Print" /* Print */;
            break;
        case 'Translate':
            iconName = "LocaleLanguage" /* LocaleLanguage */;
            break;
        case 'ShowInImmersiveReader':
            iconName = "ReadOutLoud" /* ReadOutLoud */;
            break;
        case 'ViewMessageSource':
            iconName = "OpenSource" /* OpenSource */;
            break;
        case 'Popout':
            iconName = "OpenInNewWindow" /* OpenInNewWindow */;
            break;
        case 'LikeUnlike':
            iconName = "Like" /* Like */;
            break;
        case 'ToggleDarkMode':
            iconName = "Sunny" /* Sunny */;
            break;
        default:
            iconName = '';
            break;
    }
    return {
        iconName: iconName,
        fallbackIconName: iconName,
        isImage: false,
    };
}
//# sourceMappingURL=getIconNameFromKey.js.map